import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import defaultBanner from "../../../../images/homebackground.jpg";
import "../../Landingmanagment/Landing.css";

const LogisticsBannerspage = () => {
    const [openPopup, setOpenPopup] = useState(false);

    // Popup Fields
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);

    // Image fields
    const [bannerFile, setBannerFile] = useState(null);
    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);
    const [image3, setImage3] = useState(null);
    const [image4, setImage4] = useState(null);

    // Banner List (preview)
    const [banners, setBanners] = useState([
        {
            id: 1,
            src: defaultBanner,
            type: "image",
            title: "Welcome to Maamaas",
            desc: "Experience gourmet flavors"
        }
    ]);

    // Slider settings
    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "ease-in-out",
        arrows: false,
    };


    useEffect(() => {
        const fetchBanner = async () => {
            try {
                const token = localStorage.getItem("authToken");

                const response = await axios.get(
                    "https://backend.maamaas.com/food/api/admin-banner/all",
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }
                );

                const apiData = response.data;

                // 🔍 Ensure data exists and is array
                if (!Array.isArray(apiData) || apiData.length === 0) {
                    console.warn("No banner found!");
                    return;
                }

                // 📌 Use first banner record from array
                const bannerData = apiData[0];

                setIsEditMode(true);
                setEditId(bannerData.id);
                setTitle(bannerData.companyName || "");
                setDesc(bannerData.description || "");

                const images = [
                    bannerData.banner,
                    bannerData.image1,
                    bannerData.image2,
                    bannerData.image3,
                    bannerData.image4
                ];

                const bannerList = images
                    .filter((img) => img)
                    .map((img, index) => ({
                        id: `${bannerData.id}-${index}`,
                        src: img,
                        title: bannerData.companyName || "",
                        desc: bannerData.description || ""
                    }));

                setBanners(bannerList);

            } catch (error) {
                console.error("GET Banner API Error:", error);
                alert("Error fetching banner data!");
            }
        };

        fetchBanner();
    }, []);




    // ============================
    // ⭐ SAVE BANNER WITH API
    // ============================
    const handleSave = async () => {
        const adminUserId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!bannerFile) {
            alert("Please upload a banner!");
            return;
        }

        const formData = new FormData();
        const dataObject = {
            description: desc,
            companyName: title,
            adminUserId: Number(adminUserId),
        };

        formData.append("data", new Blob([JSON.stringify(dataObject)], { type: "application/json" }));
        formData.append("banner", bannerFile);

        try {
            await axios.post(
                `https://backend.maamaas.com/food/api/admin-banner/add/${adminUserId}`,
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            alert("Banner added successfully!");
            window.location.reload();
            setOpenPopup(false);

        } catch (error) {
            console.error(error);
            alert("Failed to add!");
        }
    };


    const handleUpdate = async () => {
        const token = localStorage.getItem("authToken");
        const adminUserId = localStorage.getItem("userId");

        if (!editId) {
            alert("Invalid banner ID!");
            return;
        }

        const formData = new FormData();

        const dataObject = {
            description: desc,
            companyName: title,
            adminUserId: Number(adminUserId)
        };

        formData.append(
            "data",
            new Blob([JSON.stringify(dataObject)], { type: "application/json" })
        );

        if (bannerFile) formData.append("banner", bannerFile);
        if (image1) formData.append("image1", image1);
        if (image2) formData.append("image2", image2);
        if (image3) formData.append("image3", image3);

        try {
            await axios.put(
                `https://backend.maamaas.com/food/api/admin-banner/edit/${editId}`,
                formData,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            alert("Banner Updated Successfully!");
            window.location.reload();
            setOpenPopup(false);

        } catch (error) {
            console.error("Update Error:", error);
            alert("Update Failed: " + (error.response?.data?.message || "Server Error"));
        }
    };









    // DELETE BANNER LOCALLY ONLY
    const handleDelete = async () => {
        if (!editId) {
            alert("No banner found to delete!");
            return;
        }

        const confirmDelete = window.confirm("Are you sure you want to delete this banner?");
        if (!confirmDelete) return;

        try {
            const token = localStorage.getItem("authToken");

            await axios.delete(
                `https://backend.maamaas.com/food/api/admin-banner/delete/${editId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "accept": "*/*"
                    }
                }
            );

            alert("Banner deleted successfully!");
            window.location.reload();
            // Reset UI After Delete
            setBanners([]);
            setIsEditMode(false);
            setTitle("");
            setDesc("");
            setEditId(null);

        } catch (error) {
            console.error("Delete Error:", error);
            alert("Failed to delete banner!");
        }
    };


    return (
        <div className="container-fluid">
            <div className="row">

                <div className="col-lg-2 col-md-12 col-sm-12"></div>

                <div className="col-lg-8 col-md-12 col-sm-12" style={{ marginBottom: "10px" }}>

                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            position: "relative"
                        }}
                        className="buttons-data"
                    >

                        {/* ADD BUTTON */}
                        <button
                            onClick={() => setOpenPopup(true)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                background: "#B15DC6",
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "8px",
                                color: "#fff",
                                fontSize: "16px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                zIndex: 10
                            }}
                            className="banner-buttons-landing"
                        >
                            {isEditMode ? "✏️ Edit" : "➕ Add"}
                        </button>

                        {/* DELETE BUTTON */}
                        <button
                            onClick={handleDelete}
                            style={{
                                position: "absolute",
                                top: "10px",
                                background: "#B15DC6",
                                border: "none",
                                padding: "10px 10px",
                                borderRadius: "8px",
                                color: "#fff",
                                fontSize: "16px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                zIndex: 10
                            }}
                            className="banner-buttons-delete"
                        >
                            🗑
                        </button>

                        {/* SLIDER */}
                        <div className="sliderWrapper">
                            <Slider {...settings}>
                                {banners.map((item, index) => (
                                    <div key={index} style={styles.slideItem}>
                                        <div style={styles.imageContainer}>
                                            <img src={item.src} style={styles.image} alt="banner" />

                                            <div style={styles.overlay}>
                                                <h2 style={styles.overlayText}>{item.title}</h2>
                                                <p style={styles.overlaySubText}>{item.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>


                            {/* CSS */}
                            <style>
                                {`
                                    .sliderWrapper {
                                        margin: 0 auto;
                                    }

                                    @media (min-width: 1000px) {
                                        .sliderWrapper {
                                            width: 63vw !important;
                                        }
                                    }

                                    @media (max-width: 1000px) {
                                        .sliderWrapper {
                                            width: 100vw !important;
                                        }
                                    }

                                    .sliderWrapper img {
                                        height: 400px;
                                        object-fit: cover;
                                        border-radius: 12px;
                                        display: block;
                                    }

                                    .slick-slide > div {
                                        display: flex !important;
                                    }

                                    .slick-track {
                                        display: flex !important;
                                        align-items: center !important;
                                    }

                                    // .slick-cloned {
                                    //     display: none !important;
                                    // }
                                `}
                            </style>

                        </div>

                        {/* POPUP */}
                        {openPopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupContainer}>

                                    <span
                                        onClick={() => setOpenPopup(false)}
                                        style={{
                                            display: "block",
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            color: "#444",
                                            textAlign: "right"
                                        }}
                                    >
                                        ✖
                                    </span>

                                    <input
                                        type="text"
                                        placeholder="Enter Title"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        style={styles.input}
                                    />

                                    <textarea
                                        placeholder="Enter Description"
                                        value={desc}
                                        onChange={(e) => setDesc(e.target.value)}
                                        style={styles.textarea}
                                    ></textarea>

                                    <label style={{ fontWeight: "bold" }}>Upload Banner</label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setBannerFile(e.target.files[0])}
                                        className="popupInput"
                                    />

                                    <label style={{ fontWeight: "bold", marginTop: "10px" }}>Image 1</label>
                                    <input type="file" accept="image/*" onChange={(e) => setImage1(e.target.files[0])} className="popupInput" />

                                    <label style={{ fontWeight: "bold", marginTop: "10px" }}>Image 2</label>
                                    <input type="file" accept="image/*" onChange={(e) => setImage2(e.target.files[0])} className="popupInput" />

                                    <label style={{ fontWeight: "bold", marginTop: "10px" }}>Image 3</label>
                                    <input type="file" accept="image/*" onChange={(e) => setImage3(e.target.files[0])} className="popupInput" style={{ marginBottom: "10px" }} />
                                    <br></br>
                                    {/* <label style={{ fontWeight: "bold", marginTop: "10px" }}>Image 4</label>
                                    <input type="file" accept="image/*" onChange={(e) => setImage4(e.target.files[0])} className="popupInput" /> */}

                                    <button
                                        onClick={isEditMode ? handleUpdate : handleSave}
                                        style={styles.saveBtn}
                                    >
                                        {isEditMode ? "Update" : "Save"}
                                    </button>


                                </div>
                            </div>
                        )}

                    </div>

                </div>

                <div className="col-lg-2 col-md-12 col-sm-12"></div>

            </div>
        </div>
    );
};

export default LogisticsBannerspage;

/* ============ INLINE STYLES ============= */
const styles = {
    slideItem: { position: "relative" },

    imageContainer: {
        position: "relative",
        overflow: "hidden",
        borderRadius: 12,
    },

    image: {
        width: "100%",
    },

    overlay: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        color: "#fff",
        backgroundColor: "rgba(0,0,0,0.3)",
        padding: "15px 20px",
        borderRadius: 10,
    },

    overlayText: { margin: 0 },
    overlaySubText: { margin: 0 },

    popupOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
    },

    popupContainer: {
        width: "350px",
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
    },

    input: {
        width: "100%",
        padding: "10px",
        marginBottom: "12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
    },

    textarea: {
        width: "100%",
        padding: "10px",
        height: "70px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        // marginBottom: "12px",
    },

    saveBtn: {
        background: "#B15DC6",
        color: "#fff",
        border: "none",
        padding: "10px",
        borderRadius: "6px",
        cursor: "pointer",
        width: "100%",
        fontWeight: "bold",
    },
};
